import React from 'react'
import PropTypes from 'prop-types'
import { InputSwitch } from 'primereact/inputswitch'
import { Label } from 'reactstrap'
import './CustomPrime.css'

function CustomSwitchComponent({ checked, onChange, name, labelName, id, disabled }) {
  return (
    <>
      {labelName ? <Label className='ml-3 switchLabel mt-1'>{labelName}:</Label> : null}

      <InputSwitch
        className='ml-3 switch mt-1'
        disabled={disabled}
        checked={checked}
        id={id}
        onChange={onChange}
        name={name}
        labelname={labelName}
      />
    </>
  )
}

CustomSwitchComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  labelName: PropTypes.string,
}

export default CustomSwitchComponent
